import { DashboardPage, DashboardCard } from './PremiumDesign';
import { SkeletonBox, SkeletonText } from '@/components';

export function ProfileSettingsSkeleton() {
  return (
    <DashboardPage className="!p-0 !bg-transparent">
      <div className="flex flex-col gap-6 animate-fadeIn w-full pb-6">
        <div className="flex flex-col lg:flex-row gap-6 items-start">
          {/* LEFT COLUMN */}
          <DashboardCard className="w-full lg:w-1/3 h-auto lg:h-[470px] flex flex-col items-center justify-center p-6 lg:p-8 relative bg-white border border-border-default shadow-sm text-center min-w-0">
            <div className="relative mb-4 lg:mb-6 inline-block">
              <SkeletonBox
                className="w-32 h-32 lg:w-48 lg:h-48"
                rounded="rounded-full"
              />
            </div>
            <SkeletonText width="w-40 lg:w-52" height="h-8 lg:h-9" />
            <SkeletonText width="w-36 lg:w-48" height="h-5" className="mt-3" />
          </DashboardCard>

          {/* RIGHT COLUMN */}
          <DashboardCard
            className="w-full lg:w-2/3 h-auto lg:h-[470px] flex flex-col overflow-hidden bg-white border border-border-default shadow-sm min-w-0"
            noPadding
          >
            <div className="p-4 lg:p-5">
              <div className="flex items-center justify-between mb-3">
                <SkeletonText width="w-44" height="h-6" />
                <SkeletonBox className="w-5 h-5" rounded="rounded-md" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-8">
                {[1, 2, 3, 4].map((i) => (
                  <div key={`personal-${i}`} className="flex flex-col gap-1.5">
                    <SkeletonText width="w-24" height="h-3" />
                    <SkeletonText width="w-36" height="h-5" />
                  </div>
                ))}
              </div>
            </div>

            <hr className="border-border-default border-t m-0" />

            <div className="p-4 lg:p-5">
              <div className="flex items-center justify-between mb-3">
                <SkeletonText width="w-48" height="h-6" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-8">
                {[1, 2, 3, 4, 5, 6].map((i) => (
                  <div key={`company-${i}`} className="flex flex-col gap-1.5">
                    <SkeletonText width="w-28" height="h-3" />
                    <SkeletonText width="w-32" height="h-5" />
                  </div>
                ))}
              </div>
            </div>
          </DashboardCard>
        </div>

        {/* BOTTOM ROW SKELETON */}
        <DashboardCard
          className="flex flex-col bg-white border border-border-default shadow-sm"
          elevated={false}
        >
          <div className="flex flex-row items-start justify-between gap-4 mb-4">
            <div className="flex-1 flex flex-col gap-2">
              <SkeletonText width="w-52" height="h-6" />
              <SkeletonText width="w-72" height="h-4" />
            </div>
            <SkeletonBox className="w-11 h-6" rounded="rounded-full" />
          </div>
          <div className="flex flex-col xl:flex-row items-start xl:items-center justify-between gap-4 bg-[#EDF5EE] rounded-lg p-3 lg:p-4 w-full">
            <div className="flex items-center gap-3 w-full xl:w-auto min-w-0">
              <SkeletonBox
                className="w-12 h-12 shrink-0"
                rounded="rounded-full"
              />
              <div className="flex flex-col gap-2 flex-1 min-w-0">
                <SkeletonText width="w-32" height="h-4" />
                <SkeletonText width="w-40" height="h-3" />
              </div>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-3 w-full xl:w-auto">
              <SkeletonBox
                className="h-9 w-full sm:w-[280px]"
                rounded="rounded-md"
              />
              <SkeletonBox
                className="h-9 w-full sm:w-28"
                rounded="rounded-md"
              />
            </div>
          </div>
        </DashboardCard>
      </div>
    </DashboardPage>
  );
}
